// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + "p-awakening" + "." + "8d3fe205" + ".chunk.css";
};